module.exports = __webpack_public_path__ + "img/arab.48930e57.png";